import type { IngredientAttributes } from '~/types';

export const useIngredientStore = defineStore('ingredient', () => {
    const ingredients = ref<IngredientAttributes[]>([]);

    return {
        ingredients
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useIngredientStore, import.meta.hot));
}
